import { useMemo } from 'react';

import { ICheckin } from 'src/interfaces/Checkin';

export function useCheckinsByParticipantId(checkins: ICheckin[], editionId: string | null | undefined) {
  return useMemo(() => {
    const map: Record<string, ICheckin> = {};
    checkins.forEach(c => {
      const participantId = c.participant?.id;
      if (participantId && (!editionId || c.edition === editionId)) {
        map[participantId] = c;
      }
    });
    return map;
  }, [checkins, editionId]);
}
